import React, { useState } from 'react'
import { message, Modal, Typography } from 'antd'
import { useNavigation } from '../context/NavigationContext'

export const PossessionChangeModal = ({ 
    action,
    setPossessionChangeAction, 
    startConsultation, 
    onOk
}) => {
    const { navigateBack } = useNavigation()
    const [loading, setLoading] = useState(false)

    const _startConsultation = async () => {
        setLoading(true)
        try {
            await startConsultation()
        } catch (e) {
            if (e.message?.toLowerCase().includes("no longer available")) {
                setPossessionChangeAction("already-accepted")
            } else {
                message.error(e.message || "Error occurred while starting consultation. Please try again.")
            }
        } finally {
            setLoading(false)
        }
    }

    const modalContent = {
        "already-accepted": {
            title: "Case Already Accepted",
            text: "This case has already been accepted by another provider.",
            okText: "Go Back",
            handler: () => {
                onOk()
                navigateBack();
            }
        },
        "reassigned": {
            title: "Case reassigned",
            text: "This has been reassigned. Taking you back to case queue.",
            okText: "Go Back",
            handler: () => {
                onOk()
                navigateBack();
            }
        },
        "accept": {
            title: "Accept Case",
            text: "Please confirm that you are accepting this case",
            okText: "Ok",
            onCancel: navigateBack,
            handler: _startConsultation
        }
    }

    return (
        <Modal
            title={modalContent[action]?.title || "Case Status Update"}
            okText={modalContent[action]?.okText || "OK"}
            closable={false}
            maskClosable={false}
            centered
            visible
            okButtonProps={{ loading }}
            onOk={modalContent[action]?.handler || onOk}
            onCancel={navigateBack}
        >
            <Typography.Text strong>
                {modalContent[action]?.text || "Case status has been updated."}
            </Typography.Text>
        </Modal>
    )
}
